<template>
  <div class="md-layout">
    <h4 class="title md-layout-item md-size-100 text-primary">{{item.description.topic}}</h4>
    <hr class="text-primary" style="margin-top:140px" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["item"],
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped >
h4 {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}
hr {
  margin-top: 0px;
  border-top: 1px solid !important;
}

div.statuses {
  margin: 5px 0px 10px 0px;
}

.statuses .md-button.md-just-icon {
  height: 22px;
  min-width: 0px;
  width: 24px;
  padding: 0px;
  margin: 0px;
  overflow: hidden;
  position: relative;
}

.statuses .md-button .md-ripple {
  padding: 0px !important;
  display: flex;
  justify-content: center;
  align-items: center;

  .md-icon {
    padding: 0px !important;
  }
}

.md-card {
  padding: 10px;
  margin: 20px 0px 20px 0px;
  background: #ffffff;
  box-shadow: 0px 0px 30px #0000001a;
  border-radius: 15px;
  opacity: 1;
}

.md-card .md-card-content {
  padding: 0px;
  line-height: inherit;
}

.md-collapse-content p {
  margin-bottom: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>